import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractRtpRespondentReconService } from '../abstraction/abstract.respondent-reconcilation.service';
import { IRespondentReconTransactions } from '../../interfaces/reconciliation/respondent/respondent-recon-transaction.interface';

@Injectable({
  providedIn: 'root',
})
export class RtpRespondentReconService extends AbstractRtpRespondentReconService {
  controller = `/manager/rtp/respondentreconsummary`;
  urlGetRespondentReconGrid = `${environment.apiUrl}${this.controller}/grid`;
  urlGetRespondentReconExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;
  urlGetRespondentReconExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;
  urlGetAccountActivityRespondentTransaction = `${environment.apiUrl}${this.controller}/getrespondentrecontransactions`;

  constructor(private http: HttpClient) {
    super();
  }

  override getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRespondentReconTransactions[] | undefined> {
    return this.http
      .get<IRespondentReconTransactions[]>(
        `${this.urlGetAccountActivityRespondentTransaction}/${cycleDate}/${reconWindowId}`
      )
      .toPromise();
  }
  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetRespondentReconGrid}`, filter)
      .toPromise();
  }
  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetRespondentReconExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetRespondentReconExportExcel}`, filter).toPromise();
  }
}
